module.exports = __webpack_public_path__ + "static/media/honor6.cdfd071e.png";